import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-163d11bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clearfix" }
const _hoisted_2 = { style: {"float":"right"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 查看全部问答 ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "【最新问答】", -1))
const _hoisted_5 = {
  key: 0,
  class: "cardwrap"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "ybtitle-tooltip" }
const _hoisted_8 = ["onMouseleave", "onMouseenter"]
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_Nodata = _resolveComponent("Nodata")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["content", _ctx.theme])
  }, [
    _createElementVNode("section", null, [
      _createElementVNode("h3", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_button, {
              type: "link",
              block: "",
              size: "small",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotodetail(null)))
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_RightOutlined)
              ]),
              _: 1
            })
          ]),
          _hoisted_4
        ])
      ]),
      (_ctx.cardList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_a_spin, {
              tip: "加载中...",
              spinning: _ctx.loading,
              wrapperClassName: _ctx.PageID !== 1 && _ctx.loading ? 'bottomloading': ''
            }, {
              default: _withCtx(() => [
                _createElementVNode("ul", {
                  class: _normalizeClass(["list", {'datawrap': !_ctx.allloaded }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardList, (item, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: i,
                      onClick: ($event: any) => (_ctx.gotodetail(item, i))
                    }, [
                      _createElementVNode("div", null, _toDisplayString(item.QTime), 1),
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          visible: _ctx.overflow[i],
                          align: {
          offset: [0, 4]
        },
                          "mouse-enter-delay": 0.4,
                          "get-popup-container": _ctx.getPopupContainer
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, _toDisplayString(item.QContent), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: "overflow",
                              href: "javascript:void(0)",
                              onMouseleave: ($event: any) => (_ctx.hidetool(i)),
                              onMouseenter: ($event: any) => (_ctx.isoverflow(i, $event))
                            }, _toDisplayString(item.QContent), 41, _hoisted_8)
                          ]),
                          _: 2
                        }, 1032, ["visible", "mouse-enter-delay", "get-popup-container"])
                      ])
                    ], 8, _hoisted_6))
                  }), 128))
                ], 2)
              ]),
              _: 1
            }, 8, ["spinning", "wrapperClassName"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_Nodata, {
              class: "cardwrap",
              pagetheme: "light",
              mode: "vertical",
              customdesc: '暂无问答'
            })
          ]))
    ])
  ], 2))
}